class RippleEffect {
    constructor(element, option = {}) {
        const defaultOptions = {
          light: '.btn-primary, .btn-outline-primary, .btn-dark, .btn-secondary, .btn-outline-dark, .btn-outline-secondary',
          lightHover: 'var(--bs-gray-100-rgb), 0.3',
          dark: '.btn-light, .btn-outline-light',
          darkHover: 'var(--bs-gray-900-rgb), 0.1',
        };

        this.element = element;
        this.options = Object.assign({}, defaultOptions, option);

        this.lighClasstArr = this.options.light.replace(/\./g, '').split(', ');
        this.darkClassArr = this.options.dark.replace(/\./g, '').split(', ');
        this.ripple = this.ripple.bind(this);
    }

    ripple(e, hoverColor) {
        const ripplerContainer = this.element.querySelector('[data-ripple-container]');
        if (ripplerContainer) ripplerContainer.remove();

        const offsetInfo = this.element.getBoundingClientRect();
        const rippleContainer = document.createElement('div');
        rippleContainer.style.position = 'absolute';
        rippleContainer.style.pointerEvents = 'none';
        rippleContainer.style.borderRadius = 'inherit';
        rippleContainer.style.zIndex = 99;
        rippleContainer.style.width = offsetInfo.width + 'px';
        rippleContainer.style.left = 0 + 'px';
        rippleContainer.style.top = 0 + 'px';
        rippleContainer.style.height = offsetInfo.height + 'px';
        rippleContainer.style.overflow = 'hidden';
        rippleContainer.setAttribute('data-ripple-container', '');
        this.element.appendChild(rippleContainer);

        const maxLength = offsetInfo.width > offsetInfo.height ? offsetInfo.width : offsetInfo.height;
        const circleD = maxLength * 2;

        const ripple = document.createElement('div');
        ripple.style.position = 'absolute';
        ripple.style.width = circleD + 'px';
        ripple.style.height = circleD + 'px';
        ripple.style.borderRadius = '500px';
        ripple.style.backgroundColor = `rgba(${hoverColor})`;
        ripple.style.left = ((e.clientX - offsetInfo.left) - circleD / 2) + 'px';
        ripple.style.top = ((e.clientY - offsetInfo.top) - circleD / 2) + 'px';
        rippleContainer.appendChild(ripple);
        ripple.addEventListener('animationend', () => rippleContainer.remove(), false);
    }

    static init(e, instance) {
        instance.lighClasstArr.forEach(el => {
            if (instance.element.classList.contains(el)) {
                return instance.ripple(e, instance.options.lightHover);
            }
        });
        instance.darkClassArr.forEach(el => {
            if (instance.element.classList.contains(el)) {
                return instance.ripple(e, instance.options.darkHover);
            }
        });
    }
}

document.addEventListener('pointerdown', (e) => {
    if (e.target.classList.contains('btn') && !e.target.classList.contains('stretched-link')) {
        const ripple = new RippleEffect(e.target);
        RippleEffect.init(e, ripple);
    }
});

export default RippleEffect;